import { z } from 'zod';
/**
 * Connector views (step 33, TechSpec §5): displayable JSON a connector publishes
 * at each run with `ctx.setView(name, data)`, read by widgets through
 * `GET /sources/:id/views/:name`. A view is never a secret and never a cursor.
 */
const IsoDate = z.iso.datetime({ offset: true });
export const SourceViewResponseSchema = z.object({
    name: z.string(),
    data: z.unknown(),
    updatedAt: IsoDate,
});
/** View `upcoming` of the `calendar-ics` connector: the next entries, sorted by start. */
export const CalendarOccurrenceSchema = z.object({
    uid: z.string(),
    summary: z.string(),
    location: z.string().nullable(),
    start: IsoDate,
    end: IsoDate,
    allDay: z.boolean(),
});
export const CalendarUpcomingViewSchema = z.array(CalendarOccurrenceSchema);
export const CALENDAR_UPCOMING_VIEW = 'upcoming';
//# sourceMappingURL=views.js.map